import type React from "react";

interface TailwindSizeDisplayProps {
	positionClasses?: string;
}

// Originally found the idea on Twitter, but couldn't figure out from who but found this article that describes exactly what I was wanting: https://arrangeactassert.com/posts/tailwind-breakpoint-display/
export const TailwindSizeDisplay: React.FC<TailwindSizeDisplayProps> = ({
	positionClasses = "bottom-1 left-1", /// Change this to top-1 right-1 to move it to the top right
}) => {
	const breakpoints = ["xs", "sm", "md", "lg", "xl", "2xl"];
	const breakpointClasses = {
		xs: "block sm:hidden",
		sm: "hidden sm:block md:hidden",
		md: "hidden md:block lg:hidden",
		lg: "hidden lg:block xl:hidden",
		xl: "hidden xl:block 2xl:hidden",
		"2xl": "hidden 2xl:block",
	};

	if (import.meta.env.DEV) {
		return (
			<div
				className={`fixed ${positionClasses} z-50 flex h-6 w-6 items-center justify-center rounded-full bg-gray-800 p-3 font-mono text-xs text-white`}
			>
				{breakpoints.map((bp) => (
					// @ts-expect-error
					<div key={bp} className={breakpointClasses[bp]}>
						{bp}
					</div>
				))}
			</div>
		);
	}
};

export default TailwindSizeDisplay;
